import { InjectionToken } from '@angular/core';

import { DoodShopModel } from '@core/models/shop.model';

export type ShopHeroImageBlockViewModel = {
  shop: DoodShopModel | null;
  isShopLoading: boolean;
};

export interface ShopHeroImageBlockDataSource {
  readonly vm$: import('rxjs').Observable<ShopHeroImageBlockViewModel>;
}

export const SHOP_HERO_IMAGE_BLOCK_DATA_SOURCE = new InjectionToken<ShopHeroImageBlockDataSource>(
  'SHOP_HERO_IMAGE_BLOCK_DATA_SOURCE',
);

export const SHOP_HERO_IMAGE_BLOCK_LOADING_VM: ShopHeroImageBlockViewModel = {
  shop: null,
  isShopLoading: true,
};
